import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ErrorBoundary } from '@sentry/react';
import { FallbackUI } from 'layouts/error-fallback';
import { pushError } from 'services/error/error-logger';

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary fallback={FallbackUI} onError={pushError}>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
